import React, { useEffect, useState, useReducer, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';

import { Input, Icon, Dropdown, Button } from 'semantic-ui-react';
import { getSearchResults } from '@redturtle/iovisit-theme/actions';
import { getSearchFiltersStructures } from '@redturtle/iovisit-theme/actions';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
//import MapTemplate from '@package/components/Blocks/Listing/MapTemplate';
import config from '@plone/registry';

import { useInfiniteScroll } from '@redturtle/iovisit-theme/components';
import { RichText } from '@redturtle/iovisit-theme/components/Views';
import { motion, AnimatePresence } from 'framer-motion';

const messages = defineMessages({
  searchText: {
    id: 'struttura_ricettiva_search_text',
    defaultMessage: 'Digita la parola chiave',
  },
  clearText: {
    id: 'clear_text',
    defaultMessage: 'Cancella',
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Caricamento in corso..',
  },
  all: {
    id: 'all',
    defaultMessage: 'Tutti',
  },
  results_found: { id: 'results_found', defaultMessage: 'risultati' },
  no_results_found: {
    id: 'no_results_found',
    defaultMessage: 'Nessun risultato corrispondente ai criteri di ricerca',
  },
  search_name: {
    id: 'search_name',
    defaultMessage: 'Digita il nome',
  },
  search_services: {
    id: 'search_services',
    defaultMessage: 'Scegli i servizi',
  },
  search_accomodation_type: {
    id: 'search_accomodation_type',
    defaultMessage: 'Scegli il tipo',
  },
  search_cuisine_type: {
    id: 'search_cuisine_type',
    defaultMessage: 'Scegli il tipo di cucina',
  },
  reset_search: {
    id: 'reset_search',
    defaultMessage: 'Annulla ricerca',
  },

  timetable: {
    id: 'Opening dates and times',
    defaultMessage: 'Date e orari di apertura',
  },
});

const FILTERS_CONFIG = {
  name: { type: 'text' },
  services: { type: 'multiselect' }, // service filter not used
  accomodation_type: { type: 'multiselect' },
  cuisine_type: { type: 'multiselect' },
};
const SEARCH_TYPES_FILTERS = {
  Restaurant: ['name', 'cuisine_type'],
  Accomodation: ['name', 'accomodation_type'],
};
/**
 * View class.
 * @class View
 * @extends Component
 */
const View = ({ data, isEditMode, state }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const searchFiltersState = useSelector((state) => {
    return state.searchFiltersStructures?.subrequests?.[data.search_type] || {};
  });

  const searchState = useSelector((state) => {
    return state.searchResults;
  });

  const [filters, setFilters] = useState({});
  const [items, setItems] = useState([]);

  /***** Infinite scroll ******/
  const pageReducer = (state = {}, action) => {
    switch (action?.type) {
      case 'ADVANCE_PAGE':
        if (!searchState.loading) {
          if (
            searchState.result?.items_total > items.length &&
            items.length > 0
          ) {
            //ci sono altri elementi da caricare
            return { ...state, page: state.page + 1 };
          }
        }
        return state;
      case 'RESET':
        return { ...state, page: 1 };
      default:
        return state;
    }
  };
  const [pager, pagerDispatch] = useReducer(pageReducer, { page: 1 });
  let bottomBoundaryRef = useRef(null);
  useInfiniteScroll(bottomBoundaryRef, pagerDispatch);
  /***** end Infinite scroll *****/

  const doSearch = () => {
    if (Object.keys(filters).length === 0) {
      return;
    }
    const search_filters = Object.entries(filters).reduce(
      (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
      {},
    );
    delete search_filters.name;

    if (filters.name) {
      search_filters.SearchableText = filters.name + '*';
    }

    search_filters['Language'] = intl.locale;

    if (pager.page === 1) {
      setItems([]);
    }

    if (!searchState.loading) {
      const searchParam = {
        portal_type: data.search_type,
        fullobjects: true,
        ...search_filters,
        b_size: 2,
        b_start: (pager.page - 1) * 2, //(pager.page - 1) * config.settings.defaultPageSize,
        //sort_on: 'title',
      };

      dispatch(getSearchResults(searchParam));
    }
  };

  useEffect(() => {
    setItems(items.concat(searchState.result?.items));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState.result.items]);

  //get filters
  useEffect(() => {
    if (
      !searchFiltersState.loading &&
      !searchFiltersState.loaded &&
      data.search_type
    ) {
      dispatch(getSearchFiltersStructures(data.search_type, intl.locale));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.search_type]);

  //clear filters if data (block props) changes
  useEffect(() => {
    setFilters({});
  }, [data]);

  //do search
  useEffect(() => {
    doSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pager.page]);

  useEffect(() => {
    setItems([]);

    if (pager.page > 1) {
      pagerDispatch({ type: 'RESET' });
    } else {
      doSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const filterChange = (field, value) => {
    var f = { ...filters, [field]: value };
    if (typeof value === 'string' && value.length === 0) {
      delete f[field];
    }
    setFilters(f);
  };

  const drawFilters = () => {
    const filters_fields = SEARCH_TYPES_FILTERS[data.search_type];

    return (
      <div className={'iv--search-filters search_type_' + data.search_type}>
        {filters_fields.map((field) => {
          switch (FILTERS_CONFIG[field].type) {
            case 'text':
              return (
                <div className="iv--filter">
                  <div className="iv--search-filter-text" key={field}>
                    <Input
                      placeholder={intl.formatMessage(
                        messages['search_' + field],
                      )}
                      aria-label={intl.formatMessage(
                        messages['search_' + field],
                      )}
                      value={filters[field] || ''}
                      icon
                      onChange={(e, data) => {
                        filterChange(field, data.value);
                      }}
                      aria-controls="search-results-region-sr"
                    >
                      <input />
                      {filters[field]?.length > 0 && (
                        <Button
                          inverted
                          icon
                          title={intl.formatMessage(messages.clearText)}
                          aria-label={intl.formatMessage(messages.clearText)}
                          onClick={() => {
                            filterChange(field, '');
                          }}
                        >
                          <Icon name="delete" />
                        </Button>
                      )}
                    </Input>
                  </div>
                </div>
              );
            case 'select':
              const select_values = searchFiltersState?.data[field] ?? [];
              return (
                <div className="iv--filter">
                  <Dropdown
                    placeholder={intl.formatMessage(
                      messages['search_' + field],
                    )}
                    aria-label={intl.formatMessage(messages['search_' + field])}
                    className="iv--search-filter-select"
                    clearable
                    search
                    selection
                    options={[
                      ...select_values.map((f) => ({
                        key: f.value,
                        value: f.value,
                        text: f.label,
                      })),
                      {
                        key: 'all',
                        value: null,
                        text: intl.formatMessage(messages.all),
                      },
                    ]}
                    value={filters[field] || ''}
                    onChange={
                      (e, data) => {
                        filterChange(field, data.value);
                      }
                      // dispatchFilter({
                      //   type: filtersActions.SUBJECT,
                      //   value: data.value,
                      // })
                    }
                    key={field}
                    aria-controls="search-results-region-sr"
                  />
                </div>
              );

            case 'multiselect':
              const multiselect_values = searchFiltersState?.data[field] ?? [];
              return (
                <div className="iv--filter">
                  <Dropdown
                    placeholder={intl.formatMessage(
                      messages['search_' + field],
                    )}
                    aria-label={intl.formatMessage(messages['search_' + field])}
                    className="iv--search-filter-select"
                    multiple
                    search
                    selection
                    options={multiselect_values?.map((f) => ({
                      key: f.value,
                      value: f.value,
                      text: f.label,
                    }))}
                    value={filters[field] || []}
                    onChange={(e, data) => {
                      filterChange(field, data.value);
                    }}
                    key={field}
                    aria-controls="search-results-region-sr"
                  />
                </div>
              );
            default:
              return null;
          }
        })}
        {/* <div className="iv--search-filter-reset iv--filter">
          <Button className="reset-filters" onClick={() => setFilters({})}>
            {intl.formatMessage(messages.reset_search)}
          </Button>
        </div> */}
      </div>
    );
  };

  return (
    <div className={data['@type']} id="search-results-region-sr">
      {searchFiltersState.data ? (
        data.search_type ? (
          drawFilters()
        ) : (
          <div>Seleziona un tipo di struttura</div>
        )
      ) : (
        <div className="loading">{intl.formatMessage(messages.loading)}</div>
      )}
      <div id="result-list">
        {filters && Object.keys(filters).length > 0 && (
          <div className="iv--results-count">
            {searchState.result?.items_total > 0
              ? `${searchState.result?.items_total} ${intl.formatMessage(
                  messages.results_found,
                )}`
              : intl.formatMessage(messages.no_results_found)}
          </div>
        )}
        {items && items.length > 0 && (
          <>
            {/* <MapTemplate
              items={items}
              isEditMode={isEditMode}
              addMarkerLink={false}
            /> */}

            <AnimatePresence initial={false}>
              <div className="items-list">
                {items.map((item) => {
                  const timetable = RichText({
                    content: item.timetable,
                    title: intl.formatMessage(messages.timetable),
                    titleTag: 'h4',
                  });
                  return (
                    <motion.div
                      key={item.UID}
                      className="item"
                      initial={{ scale: 0.85, opacity: 0.1 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0.7, opacity: 0.2 }}
                    >
                      <figure>
                        {item?.preview_image ? (
                          <img
                            src={item.preview_image.scales.preview.download}
                            alt={item.title}
                            loading="lazy"
                          />
                        ) : (
                          item[config.settings.listingPreviewImageField] && (
                            <img
                              src={
                                item[config.settings.listingPreviewImageField]
                                  .scales.preview.download
                              }
                              alt={item.title}
                              loading="lazy"
                            />
                          )
                        )}
                      </figure>

                      <div className="item-data">
                        <h3>
                          <UniversalLink
                            item={!isEditMode ? item : null}
                            href={isEditMode ? '#' : null}
                          >
                            {item.title}
                          </UniversalLink>
                        </h3>
                        {item.accomodation_type && (
                          <div className="type">
                            {item.accomodation_type.title}
                          </div>
                        )}

                        {item.restaurant_type && (
                          <div className="type">
                            {item.restaurant_type.map((t, i) => {
                              var sep =
                                i + 1 < item.restaurant_type.length ? ', ' : '';
                              return t.title + sep;
                            })}
                          </div>
                        )}
                        {item.cuisine_type && (
                          <div className="cuisine_type">
                            {item.cuisine_type.map((t, i) => {
                              var sep =
                                i + 1 < item.cuisine_type.length ? ', ' : '';
                              return t.title + sep;
                            })}
                          </div>
                        )}

                        {item.geolocation?.description && (
                          <p>{item.geolocation.description}</p>
                        )}
                        {item.phone && (
                          <p>
                            <Icon name="phone" />{' '}
                            <a href={'tel:' + item.phone}>{item.phone}</a>
                          </p>
                        )}
                        {item.email && (
                          <p>
                            <Icon name="mail" />
                            <a href={'mailto:' + item.email}>{item.email}</a>
                          </p>
                        )}

                        {item.website && (
                          <p>
                            <Icon name="world" />
                            <a
                              href={item.website}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              {item.website}
                            </a>
                          </p>
                        )}

                        {timetable}
                      </div>
                    </motion.div>
                  );
                })}
              </div>
            </AnimatePresence>
          </>
        )}

        <div id="page-bottom-boundary" ref={bottomBoundaryRef}></div>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
